export const CustomDatePickerInput = (props: React.HTMLProps<HTMLInputElement>, ref: React.Ref<HTMLInputElement>) => (
    <input type='text' placeholder='Data di nascita' {...props} className="form-input" ref={ref} />
);